import { SagaIterator } from 'redux-saga';
import { isLocationChangeAction } from 'src/modules/routing/actions/LocationChange';
import { ROUTE_CHANGE } from 'src/modules/routing/actions/RouteChange';
import { locationChangeSaga } from 'src/modules/routing/sagas/locationChangeSaga';
import { routeChangeSaga } from 'src/modules/routing/sagas/routeChangeSaga';
import { takeLatest } from 'typed-redux-saga';

export function* routingSaga(): SagaIterator<void> {
  yield* takeLatest(isLocationChangeAction, locationChangeSaga);
  yield* takeLatest(ROUTE_CHANGE.isRequest, routeChangeSaga);
}
